export default defineNuxtRouteMiddleware((to, from) => {
    if (from.name && !(from.name as string).includes('esav')) {
        try {
            sessionStorage.setItem('lastFlowRoute', JSON.stringify({ name: from.name, params: from.params, query: from.query }));
        }
        catch (error) {

        }
    }
});
